import { makeVar, useReactiveVar } from '@apollo/client';
import type { TabType } from '../types';

export type BottomBarUiState = {
    activeTab: TabType | null;
    isMinimized: boolean;
    hasUnseenAccessoryChanges: boolean;
    allowOpeningAccessoryTabDirectly: boolean;
    lastSeenProductSku?: string;
};

const bottomBarUiState = makeVar<BottomBarUiState>({
    activeTab: null,
    isMinimized: false,
    hasUnseenAccessoryChanges: false,
    allowOpeningAccessoryTabDirectly: true
});

export const useBottomBarUiState = (): BottomBarUiState => useReactiveVar(bottomBarUiState);

export const setBottomBarUiState = (partial: Partial<BottomBarUiState>): void => {
    bottomBarUiState({ ...bottomBarUiState(), ...partial });
};
